import { withPrefix } from "gatsby"
import React from "react"
import Helmet from "react-helmet"

export default function Page() {
  return (
    <div className="interactive-video">
      <Helmet>
        <title>EDUbox: Interactieve Video</title>
        <link rel="stylesheet" href={withPrefix("interactive-video.css")} />
        <meta name="keywords" content="EDUbox,lesmateriaal, lestool, VRT, interactieve video" />
        <meta name="description" content="Dompel je klas onder in boeiende thema’s met interactieve leerervaringen op maat van jongeren, verrijkt met audiovisueel materiaal en VRT-experten." />
        <meta name="author" content="VRT" />
        <meta name="language" content="nl" />
        <meta name="robots" content="index,follow" />
        <meta property="og:author" content="https://www.facebook.com/vrt.be" />
        <meta property="og:title" content="EDUbox | VRT.be" />
        <meta property="og:description" content="edubox" />
        <meta property="og:type" content="home" />
        <meta property="og:url" content="https://www.vrt.be/nl/edubox/catalogus/" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
        <meta http-equiv="cleartype" content="on" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@vrt" />
        <meta name="twitter:creator" content="@vrt" />
        <meta name="twitter:title" content="EDUbox | VRT.be" />
        <meta name="twitter:description" content="Dompel je klas onder in boeiende thema’s met interactieve leerervaringen op maat van jongeren, verrijkt met audiovisueel materiaal en VRT-experten." />
        <meta name="twitter:url" content="https://www.vrt.be/nl/edubox/catalogus/" />
        <meta property="og:image" content="../../assets/img/banner.jpeg" />
        <meta name="twitter:image" content="../../assets/img/banner.jpeg" />
        <link rel="apple-touch-icon" sizes="180x180" href="../../assets/img/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="../../assets/img/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="../../assets/img/favicon-16x16.png" />
        <link rel="manifest" href="../../assets/img/site.webmanifest" />
      </Helmet>
      <div
        id="loadingscreen"
        style={{
          zIndex: 9999,
          width: "100%",
          height: "100%",
          position: "fixed",
          top: 0,
          left: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "white",
        }}
      >
        <div>
          <p id="progressbartext" style={{ textAlign: "center" }}>
            0%
          </p>
          <div id="overview" style={{
                display: "none"}}></div>
          <div
            id="progressbar"
            style={{
              width: "200px",
              height: "10px",
              borderRadius: "10px",
              backgroundColor: "rgb(230,230,230)",
              margin: "20px auto 0 auto",
              overflow: "hidden",
            }}
          >
            <div
              id="progress"
              style={{
                transition: "width .2s ease",
                marginLeft: 0,
                height: "100%",
                width: "0%",
                backgroundColor: "#031037",
              }}
            ></div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "none",
          visibility: "hidden",
        }}
      >
        <form id="submitform" method="get">
          <input id="formulier-vraag-1" name="formulier-vraag-1" type="text" />
          <input id="formulier-vraag-2" name="formulier-vraag-2" type="text" />
          <input id="formulier-vraag-3" name="formulier-vraag-3" type="text" />
        </form>
      </div>
      <div className="video-container">
        <div id="player-controler-start" className="player-overlay">
          <div>
            <div id="startscreen_title"></div>
            <div id="startscreen_text"></div>
            <div className="buttonposition">
              <button className="button" id="startbutton_text">
                Start de video
              </button>
              <div id="button-extra-explanation">
                (Dit venster zal als een volledig scherm openen.)
              </div>
            </div>
          </div>
        </div>
        <div id="player-controler-end" className="player-overlay hidden">
          <div>
            <div id="endscreen_text"></div>
          </div>
        </div>
        <div id="player"></div>
      </div>
      <div id="screens"></div>

      <Helmet>
        <script src="https://cdn.jsdelivr.net/npm/marked@7.0.4/lib/marked.umd.min.js"></script>
        <script src={withPrefix("interactive-video.js")}></script>
      </Helmet>
    </div>
  )
}
